import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter
} from '@angular/core';
import { TokenService } from 'src/app/Services/token.service';
import { AuthService } from 'src/app/Services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { GrievanceServiceService } from 'src/app/Services/grievance-service.service';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewGrievanceUserComponent } from './view-grievance-user/view-grievance-user.component';
import { MatDialog } from '@angular/material/dialog';
import { ViewGrievanceAttachmentComponent } from '../users/consultant/consultant-open-grievances/view-grievance-attachment/view-grievance-attachment.component';
import * as myGlobals from '../../app.component';

@Component({
  selector: 'app-grievance-table',
  templateUrl: './grievance-table.component.html',
  styleUrls: ['./grievance-table.component.scss']
})
export class GrievanceTableComponent implements OnInit {
  public loggedIn: boolean = false;
  userDetails: any = [];
  searchText:any='';
  displayedColumns: string[] = [
    'id',
    'grievance_id',
    'nature',
    'subject',
    'committed_on',
    'status',
    'view'
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Output() parentFun = new EventEmitter();
  grievances: any;
  recentGrievances: any;
  public baseUrl = myGlobals.baseFileUrl;

  constructor(
    private token: TokenService,
    public dialog: MatDialog,
    private auth: AuthService,
    private toastr: ToastrService,
    private grievanceService: GrievanceServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.auth.authStatus.subscribe(value => (this.loggedIn = value));
    this.getUsersGrievances();
    this.getUser();
  }

  getUsersGrievances() {
    this.grievanceService
      .getUsersGrievances()
      .subscribe(data => this.handleResponse(data));
  }

  handleResponse(data) {
    if (data['type'] == 'Success') {
      this.recentGrievances = data['recentGrievances'];
      this.dataSource = new MatTableDataSource(data['usersGrievances']);
      this.dataSource.filterPredicate = this.filterObject;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      if(this.searchText){
        this.applyFilter();
      }
    } else {
      this.toastr.error(data['message']);
    }
  }

  filterObject(obj, filter): boolean {
    const matchFilter = [];
    const filterArray = filter.split(' ');
    const columns = (<any>Object).values([
      String(obj['grievance_id']),
      String(obj['nature']),
      String(obj['subject']),
      String(obj['status']),
    ]);

    filterArray.forEach(filter => {
      const customFilter = [];
      columns.forEach(column => customFilter.push(column.toLowerCase().includes(filter)));
      matchFilter.push(customFilter.some(Boolean)); // OR
    });
    return matchFilter.every(Boolean);
  }

  addGrievancePage() {
    this.router.navigateByUrl('grievance');
  }

  getUser() {
    this.grievanceService
      .getUser()
      .subscribe(data => (this.userDetails = data['user']));
  }

  back() {
    switch (this.userDetails['role']) {
      case 'Expert':
        this.router.navigateByUrl('expert');
        break;
      case 'Moderator':
        this.router.navigateByUrl('moderator');
        break;
      case 'Institute':
        this.router.navigateByUrl('institute');
        break;
      case 'Student':
        this.router.navigateByUrl('student');
        break;
      case 'HOD':
        this.router.navigateByUrl('hod');
        break;
      case 'Faculty':
        this.router.navigateByUrl('faculty');
        break;
    }
  }

  viewGrievanceReply(data) {
    const dialogRef = this.dialog.open(ViewGrievanceUserComponent, {
      data: { data },
      height: 'auto',
      width: '80%'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit();
    });
  }

  applyFilter() {
    const filterValue = this.searchText;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getPageSizes(): number[] {
    if (this.dataSource.data.length > 100) {
      return [10, 25, 50, 100, this.dataSource.data.length];
    } else if (
      this.dataSource.data.length > 50 &&
      this.dataSource.data.length <= 100
    ) {
      return [10, 25, 50, this.dataSource.data.length];
    } else if (
      this.dataSource.data.length > 25 &&
      this.dataSource.data.length <= 50
    ) {
      return [10, 25, this.dataSource.data.length];
    } else if (
      this.dataSource.data.length > 10 &&
      this.dataSource.data.length <= 25
    ) {
      return [10, this.dataSource.data.length];
    } else {
      return [this.dataSource.data.length];
    }
  }

  viewImg(data) {
    data = '/Grievances/' + data;
    const dialogRef = this.dialog.open(ViewGrievanceAttachmentComponent, {
      data: { data }
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  viewReplyImg(data) {
    data = '/Grievances_reply/' + data;
    const dialogRef = this.dialog.open(ViewGrievanceAttachmentComponent, {
      data: { data }
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  logout(event: MouseEvent) {
    event.preventDefault();
    this.token.remove();
    this.auth.changeStatus(false);
    this.auth.logout();
    window.location.replace('/login');
  }
}
